import * as React from "react"
import { AdminShell } from "@/components/AdminShell"
import { AppShell } from "@/components/AppShell"

/** Official (admin) generations live in the admin area; everything else in the app shell. */
export function ShellFor({ official, children }: { official: boolean; children: React.ReactNode }) {
  return official ? <AdminShell>{children}</AdminShell> : <AppShell>{children}</AppShell>
}
